import MastermindImg from '../../../assets/FreeTrialLandingPage/MastermindCollage.png';

function HeroBanner() {
  return (
    <section className='text-center before:block before:absolute before:-inset-1  before:bg-gradient-to-b before:from-highlight-eggshell before:to-white before:h-full before:-z-1 relative'>
      <div className='max-w-6xl mx-auto px-4 sm:px-6'>
        {/* Hero content */}
        <div className='pt-16 md:pt-4 '>
          {/* Section header */}
          <div className=' pb-12 md:pb-16'>
            <h1 className='text-4xl md:text-6xl font-black leading-none mt-8 mb-4 text-text-main'>
              Join a trial mastermind session today - free!
            </h1>
            <div className='max-w-4xl mx-auto'>
              <p className='text-xl text-text-main mb-8'>
                Being a founder in Singapore is lonely and difficult. Join a mastermind group of 6 founders to connect
                with peers, exchange ideas, and overcome challenges together.
              </p>
              <div className='mx-auto max-w-sm sm:max-w-none sm:flex sm:justify-center'>
                <a href='https://buy.stripe.com/28o9EFdMm8qC7QI4gk'>
                  <div className=' bg-primary-main hover:bg-primary-hover text-white py-4 px-4 md:px-10 rounded-full items-center'>
                    <h3 className='text-xl md:text-2xl font-bold'>Claim your free trial</h3>
                    <p className='text-xs sm:text-sm font-light'>Join a mastermind group of founders today.</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='max-w-7xl mx-auto px-4 sm:px-6'>
        <img className='mx-auto drop-shadow-3xl mb-10' src={MastermindImg} alt='Logo' />
      </div>
      <a href='#skills' className='font-bold text-2xl text-link-main hover:text-link-hover underline'>
        See what our members are saying
      </a>
    </section>
  );
}

export default HeroBanner;
